import { Box, IconButton, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const PageTitle = ({ title }) => {
  const navigate = useNavigate();

  const [prefix, suffix] = title.split(":");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        mb: { xs: 3, md: 5 },
      }}
    >
      <IconButton
        sx={{
          bgcolor: "#e7e7e7",
          ":hover": { bgcolor: "#d8d8d8" },
        }}
        onClick={() => navigate(-1)}
      >
        <ArrowBackIcon sx={{ color: "#1DA7A7" }} />
      </IconButton>

      <Typography
        variant="h4"
        sx={{
          fontSize: { xs: 16, sm: 18, md: 22 },
          fontWeight: 400,
          p: 0,
        }}
      >
        {prefix}
        {suffix && (
          <Typography
            component="span"
            sx={{
              fontSize: { xs: 16, sm: 18, md: 22 },
              fontWeight: 600,
            }}
          >
            :{suffix}
          </Typography>
        )}
      </Typography>
    </Box>
  );
};

export default PageTitle;
